const variants = {
  warning: {
    background: "#FFB23719",
    borderColor: "warning",
  },
  danger: {
    background: "#ED4B9E19",
    borderColor: "failure",
  },
  success: {
    background: "rgba(49, 208, 170, 0.1)",
    borderColor: "success",
  },
  info: {
    background: "rgba(10, 126, 214, 0.1)",
    borderColor: "#0A7ED6",
  },
  primary: {
    background: "rgba(118, 69, 217, 0.1)",
    borderColor: "secondary",
  },
};

export default variants;
